import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const showSharedFileAuthor: boolean = getFeature('show-shared-file-author') || false;
